import { render } from "./Test.vue?vue&type=template&id=5c86aba8"
import script from "./Test.vue?vue&type=script&lang=ts"
export * from "./Test.vue?vue&type=script&lang=ts"
script.render = render

export default script